import { render } from "./SaveConfigComponent.vue?vue&type=template&id=deeb0416&scoped=true"
import script from "./SaveConfigComponent.vue?vue&type=script&lang=js"
export * from "./SaveConfigComponent.vue?vue&type=script&lang=js"

import "./SaveConfigComponent.vue?vue&type=style&index=0&id=deeb0416&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deeb0416"]])

export default __exports__